import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api.js';

interface Partner {
  public_key: string;
  partner_code?: string;
  name?: string;
  is_active?: boolean;
  is_suspended?: boolean;
}

export function AdminPartners() {
  const { data, isPending } = useQuery({
    queryKey: ['admin', 'partners'],
    queryFn: () => api.get<{ partners: Partner[] }>('/api/admin/partners'),
  });
  if (isPending) return <div className="card text-sm text-slate-500">Loading…</div>;
  const rows = data?.partners ?? [];
  return (
    <div className="card">
      <h3 className="text-base font-semibold">Partners / Resellers</h3>
      {rows.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500">No partners yet. Hidden behind <code>flag:resellers</code>.</p>
      ) : (
        <table className="mt-3 min-w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left py-2">Name</th>
              <th className="text-left py-2">Code</th>
              <th className="text-left py-2">Public key</th>
              <th className="text-left py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.public_key} className="border-b last:border-b-0">
                <td className="py-2">{p.name ?? '—'}</td>
                <td className="py-2 font-mono text-xs">{p.partner_code ?? '—'}</td>
                <td className="py-2 font-mono text-xs break-all">{p.public_key}</td>
                <td className="py-2">
                  {p.is_suspended ? (
                    <span className="badge-error">suspended</span>
                  ) : p.is_active ? (
                    <span className="badge-success">active</span>
                  ) : (
                    <span className="badge-warning">inactive</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
